import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import "./Calendar.css";
import NavigationHeader from './NavigationHeader';
import CalendarDayView from './CalendarDayView';
import CalendarWeekView from './CalendarWeekView';
import CalendarMonthView from './CalendarMonthView';
import { getEmployeePlan } from '../../actions/userActions/EmployeePlanAction';
import { useDispatch, useSelector } from 'react-redux';
import CalendarListView from './CalendarListView';
import CopyPlanMenu from '../Copy Planner/CopyPlanMenu';



const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
};

const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
};
const getCurrentWeek = (currentDate) => {
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
    const weekArray = [];
    for (let i = 0; i < 7; i++) {
        const day = new Date(startOfWeek);
        day.setDate(startOfWeek.getDate() + i);
        weekArray.push({
            day: day.getDate(),
            month: day.getMonth() + 1,
            year: day.getFullYear(),
            isCurrentMonth: day.getMonth() === currentDate.getMonth(),
        });
    }
    return weekArray;
};
const formatHour = (hour) => {
    const suffix = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${formattedHour} ${suffix}`;
};

const CustomCalendar = ({ onDayClick, onPasteClick, currentDate, setCurrentDate, isPlannerOpen}) => {
    const DAYVIEW = "timeGridDay";
    const WEEKVIEW = "timeGridWeek";
    const MONTHVIEW = "dayGridMonth";
    const LISTVIEW = "list";
    const [myPlan, setMyPlan] = useState(true);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [employeePlans, setEmployeePlans] = useState([]);
    const [filteredPlan, setFilteredPlan] = useState();
    // const [currentDate, setCurrentDate] = useState(new Date());
    const [days, setDays] = useState([]);
    const calendarRef = useRef(null);
    const [currentMonth, setCurrentMonth] = useState("");
    const [selectedView, setSelectedView] = useState(MONTHVIEW);
    const [weekDays, setWeekDays] = useState([]);
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.result[0]?.user.id;
    const dispatch = useDispatch();
    const employeePlan = useSelector((state) => state.employeePlan_reducer.employeePlan);
    const addPlanStatus = useSelector(state => state.employeePlan_reducer.addEmployeePlan);
     const [showCopyMenu, setShowCopyMenu] = useState(false);
     const [copyMode, setCopyMode] = useState(false);
    const [copiedPlans, setCopiedPlans] = useState([]);
    const [copyFeedback, setCopyFeedback] = useState(false);

    const changeView = (viewName) => {
        setSelectedView(viewName);
    };
    const changeWeek = (direction) => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate);
            newDate.setDate(prevDate.getDate() + direction * 7);
            return newDate;
        });
    };    
    const changeDay = (direction) => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate);
            newDate.setDate(prevDate.getDate() + direction);
            return newDate;
        });
    }; 
    const changeMonth = (direction) => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate);
            newDate.setMonth(prevDate.getMonth() + direction);
            return newDate;
        });
    };   
    const changeMonthOrWeek = (direction) => {
        if (selectedView === WEEKVIEW) {
            changeWeek(direction);
        } else if (selectedView === DAYVIEW) {
            changeDay(direction);
        } else {
            changeMonth(direction);
        }
    };

    const handleMenuClose = () => {
        setCopyMode(false);
        setShowCopyMenu(false);
    }

    useEffect(() => {
        if (selectedView === WEEKVIEW) {
            setWeekDays(getCurrentWeek(currentDate));
        } else {
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            const firstDay = getFirstDayOfMonth(year, month);
            const daysInMonth = getDaysInMonth(year, month);

            const daysArray = [];
            const prevMonthDays = getDaysInMonth(year, month - 1);

            for (let i = 0; i < firstDay; i++) {
                daysArray.push({
                    day: prevMonthDays - (firstDay - 1 - i),
                    isCurrentMonth: false,
                    month: month === 0 ? 12 : month,
                    year: month === 0 ? year - 1 : year,
                });
            }

            for (let day = 1; day <= daysInMonth; day++) {
                daysArray.push({
                    day,
                    isCurrentMonth: true,
                    month: month + 1,
                    year,
                });
            }

            const remainingCells = 7 - (daysArray.length % 7);
            if (remainingCells !== 7) {
                for (let day = 1; day <= remainingCells; day++) {
                    daysArray.push({
                        day,
                        isCurrentMonth: false,
                        month: month + 2 > 12 ? 1 : month + 2,
                        year: month + 2 > 12 ? year + 1 : year,
                    });
                }
            }

            setDays(daysArray);
        }
    }, [currentDate, selectedView]);

    const formatMonth = () => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return `${months[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
    };

    const isSameDate = (date1, date2) => {
        return (
            date1.day === date2.getDate() &&
            date1.month === date2.getMonth() + 1 &&
            date1.year === date2.getFullYear()
        );
    };
    const isSameDateDay = (date1, date2) => {
        return (
            date1.day === date2.getDate() &&
            date1.month === date2.getMonth() + 1 &&  
            date1.year === date2.getFullYear()
        );
    };    

    useEffect(() => {
        const filteredPlandata = employeePlans?.find(plan => {
            const monthMatches = plan.month === currentDate.getMonth() + 1;
            const yearMatches = plan.year === currentDate.getFullYear();

            if (myPlan) {
                return monthMatches && yearMatches && plan.employeeId == userId;
            } else if (selectedEmployee) {
                return monthMatches && yearMatches && plan.employeeId == selectedEmployee && (plan.statusId === 2 || plan.statusId === 3);
            }
            return false;
        });

        setFilteredPlan(filteredPlandata);
    }, [employeePlans, currentDate, myPlan, selectedEmployee, userId]);

    useEffect(() => {
        if (employeePlan && employeePlan.length !== 0 && employeePlan !== "isLoading" && employeePlan.result && employeePlan.result.length !== 0) {
            setEmployeePlans(prevPlans => {
                const newPlan = employeePlan.result[0];
                const planIndex = prevPlans.findIndex(plan => plan.id === newPlan.id);

                if (planIndex !== -1) {
                    const updatedPlans = [...prevPlans];
                    updatedPlans[planIndex] = newPlan;
                    return updatedPlans;
                } else {
                    return [...prevPlans, newPlan];
                }
            });
        }

    }, [employeePlan]);
    // Initial fetch is handled by NavigationHeader's [currentMonth, myPlan, selectedEmployee] effect
    useEffect(() => {
        if (addPlanStatus && addPlanStatus !== "isLoading" && addPlanStatus === true) {
            if (userId && currentDate) {
                const employeeId = userId;
                const month = currentDate.getMonth() + 1;
                const year = currentDate.getFullYear();
                dispatch(getEmployeePlan(employeeId, month, year));
            }
        }
    }, [addPlanStatus]);
    useEffect(() => {
        const newMonth = currentDate.getMonth() + 1;
         if (currentMonth !== newMonth) {
        setCurrentMonth(newMonth);
        setShowCopyMenu(false);  
        setCopyMode(false);     
    }
    }, [currentDate, currentMonth]);
    const toggleCopyMenu = () => {
        setShowCopyMenu(true);
        setCopyMode(true);
    }

    const handleCopyPlan = () => {
 if (copiedPlans.length === 0) {
    return;
  }

  setCopyFeedback(true);
  localStorage.removeItem("copiedPlanData");

  const planDataToCopy = copiedPlans.map(({ day, events }) => {
    const paddedMonth = day.month < 10 ? '0' + day.month : day.month;
    const paddedDay = day.day < 10 ? '0' + day.day : day.day;
    const date = `${day.year}-${paddedMonth}-${paddedDay}`;

    return {
      date,
      employeeId: events?.employeeId || filteredPlan?.employeeId || userId,
      planDetails: events?.planDetails || [],
    };
  });

  localStorage.setItem("copiedPlanData", JSON.stringify(planDataToCopy));
console.log("copiedPlanData", planDataToCopy)
setCopyMode(false);
    setTimeout(() => {
    setCopyFeedback(false);
    setShowCopyMenu(false);  
  }, 1200); 

};


const handlePasteMenuOpen = () => {
  onPasteClick(); 
};



    return (
        <>
            <div className="calender-container">
                <NavigationHeader
                    currentDate={currentDate}
                    selectedView={selectedView}
                    changeView={changeView}
                    changeMonthOrWeek={changeMonthOrWeek}
                    formatMonth={formatMonth}
                    planStatus={filteredPlan ? filteredPlan.statusId : 1}
                    planId={filteredPlan?.id}
                    userId={userId}
                    myPlan={myPlan}
                    setMyPlan={setMyPlan}
                    selectedEmployee={selectedEmployee}
                    setSelectedEmployee={setSelectedEmployee}
                    handleCopyClick={toggleCopyMenu}
                    handlePasteClick={handlePasteMenuOpen}
                    copyFeedback={copyFeedback}
                    copyMode={copyMode}
                    isPlannerOpen= {isPlannerOpen}
                />

                <div className="main-calendar">
                    {selectedView === DAYVIEW ? (
                        <CalendarDayView currentDate={currentDate} isSameDateDay={isSameDateDay} formatHour={formatHour} planDates={filteredPlan?.employeePlanDates} planStatus={filteredPlan?.statusId ? filteredPlan.statusId : 1} onDayClick={onDayClick} planId={filteredPlan?.id} myPlan={myPlan} isPlannerOpen= {isPlannerOpen}/>
                    ) : selectedView === WEEKVIEW ? (
                        <CalendarWeekView weekDays={weekDays} isSameDate={isSameDate} formatHour={formatHour} planDates={filteredPlan?.employeePlanDates} planStatus={filteredPlan?.statusId ? filteredPlan.statusId : 1} onDayClick={onDayClick} planId={filteredPlan?.id} myPlan={myPlan} isPlannerOpen= {isPlannerOpen}/>
                    ) : selectedView === MONTHVIEW ? (
                        <CalendarMonthView  days={days} planDates={filteredPlan?.employeePlanDates} planStatus={filteredPlan?.statusId ? filteredPlan.statusId : 1} onDayClick={onDayClick} planId={filteredPlan?.id} myPlan={myPlan}  copyMode={copyMode}  onCopySelectionChange={(selected) => setCopiedPlans(selected)} isPlannerOpen= {isPlannerOpen}/>
                    ) : (
                        <CalendarListView planDates={filteredPlan?.employeePlanDates} />
                    )
                    }
                </div>
                        {showCopyMenu && (
                        <div className="copy-plan-floating">
                            <CopyPlanMenu
                            onClose={handleMenuClose}
                            onCopy={handleCopyPlan}
                            copyFeedback={copyFeedback}
                            />
                        </div>
                        )}

            </div>
        </>
    );
};

export default CustomCalendar;
